var _style, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1844.6 1508",
    style: {
      enableBackground: "new 0 0 1844.6 1508"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:url(#SVGID_1_);stroke-width:8;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:url(#SVGID_00000050658347665702030410000017704216445816136084_);stroke-width:8;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:url(#SVGID_00000089543222980368276970000013903695337140927874_);stroke-width:8;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:url(#SVGID_00000163038079874909167690000000006306066235272857_);stroke-width:8;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:url(#SVGID_00000123399073544382017240000011129740033787298719_);stroke-width:8;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:url(#SVGID_00000093893974113848344610000007006297389651447981_);stroke-width:8;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:url(#SVGID_00000097485527091178677430000013929255131247591312_);stroke-width:8;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:url(#SVGID_00000080206047350749816300000009500256369920693947_);stroke-width:8;stroke-miterlimit:10;}\n\t\n\t\t.st8{fill:none;stroke:url(#SVGID_00000111889428102689430270000003040416627918490764_);stroke-width:8.0004;stroke-miterlimit:10.0005;}\n\t.st9{fill:none;stroke:url(#SVGID_00000127006164202067349600000011981319529840947884_);stroke-width:8;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:url(#SVGID_00000059272449446828625320000006836004258207253392_);stroke-width:8;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:url(#SVGID_00000038372639859937641200000001291747550141265855_);stroke-width:8;stroke-miterlimit:10;}\n\t\n\t\t.st12{fill:none;stroke:url(#SVGID_00000147906601730697832120000003815343114067412405_);stroke-width:8.0004;stroke-miterlimit:10.0005;}\n\t.st13{fill:none;stroke:url(#SVGID_00000029729149591753322790000017472628920405457551_);stroke-width:8;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:url(#SVGID_00000079444506493575240270000004448244706278620808_);stroke-width:8;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:url(#SVGID_00000177470107183841728000000009539472867311905189_);stroke-width:8;stroke-miterlimit:10;}\n\t.st16{fill:none;stroke:url(#SVGID_00000077298925659911756540000012385686372007858305_);stroke-width:8;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:url(#SVGID_00000176023713403217058140000011160176417075398586_);stroke-width:8;stroke-miterlimit:10;}\n\t.st18{fill:url(#SVGID_00000147938291467829000110000015688633017866590890_);}\n\t.st19{fill:url(#SVGID_00000093135036437510254060000013560755134287232155_);}\n\t.st20{fill:url(#SVGID_00000013192269654727115720000005451809615891885753_);}\n\t.st21{fill:url(#SVGID_00000034071671500815272770000006596887705516805764_);}\n\t.st22{fill:url(#SVGID_00000150077995352524409860000004218769917790282161_);}\n\t.st23{fill:url(#SVGID_00000027576360210073930920000012603655087670596779_);}\n\t.st24{fill:url(#SVGID_00000064334478908950364200000003719817579208205723_);}\n\t.st25{fill:url(#SVGID_00000130613672367220767470000017133974080560415647_);}\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 1023.0784,
    cy: 538.3485,
    r: 536.6786,
    gradientTransform: "matrix(0.9964 -1.177597e-03 1.177597e-03 0.9964 -112.8505 219.3258)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F9F2BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67658D"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1795 -0.9838 0.9838 0.1795 5.5743 1515.7285)",
    className: "st0",
    cx: 911.4,
    cy: 754.5,
    rx: 750,
    ry: 74.7
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000082348244379245238560000017936827082891576971_",
    cx: 911.4362,
    cy: 270.5226,
    r: 536.0556,
    gradientTransform: "matrix(1 0 0 1 0 484)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9F2BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1CB5F"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000082348244379245238560000017936827082891576971_)",
      strokeWidth: 8,
      strokeMiterlimit: 10
    },
    cx: 911.4,
    cy: 754.5,
    rx: 74.7,
    ry: 750
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000016790475226107395690000018432217532163047598_",
    cx: 2445.1829,
    cy: 1763.7887,
    r: 536.31,
    gradientTransform: "matrix(-0.9339 0.3474 -0.3474 -0.9339 3814.2925 1552.3176)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F9F2BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67658D"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9848 -0.1736 0.1736 0.9848 -117.1747 169.7321)",
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000016790475226107395690000018432217532163047598_)",
      strokeWidth: 8,
      strokeMiterlimit: 10
    },
    cx: 911.4,
    cy: 754.5,
    rx: 74.7,
    ry: 750
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000031918919677920571740000004421873804779552897_",
    cx: 2444.3599,
    cy: 1762.2864,
    r: 536.0556,
    gradientTransform: "matrix(-0.9376 0.3476 -0.3476 -0.9376 3815.9353 1557.2885)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9F2BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1CB5F"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9376 -0.3476 0.3476 0.9376 -205.4335 363.8535)",
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000031918919677920571740000004421873804779552897_)",
      strokeWidth: 8,
      strokeMiterlimit: 10
    },
    cx: 911.4,
    cy: 754.5,
    rx: 74.7,
    ry: 750
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000000199213617134601310000010293571915570796455_",
    cx: 906.3005,
    cy: 1197.0479,
    r: 535.9106,
    gradientTransform: "matrix(0.7528 0.6528 -0.6528 0.7528 1007.8693 -740.6123)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F9F2BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67658D"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7809 -0.6247 0.6247 0.7809 -271.6225 734.7131)",
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000000199213617134601310000010293571915570796455_)",
      strokeWidth: 8,
      strokeMiterlimit: 10
    },
    cx: 911.4,
    cy: 754.5,
    rx: 750,
    ry: 74.7
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000180349500483283903840000011458336641542385297_",
    cx: 907.9493,
    cy: 1196.7067,
    r: 536.0556,
    gradientTransform: "matrix(0.7547 0.6561 -0.6561 0.7547 1011.3083 -744.3118)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9F2BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1CB5F"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6561 -0.7547 0.7547 0.6561 -255.9652 947.3809)",
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000180349500483283903840000011458336641542385297_)",
      strokeWidth: 8,
      strokeMiterlimit: 10
    },
    cx: 911.4,
    cy: 754.5,
    rx: 750,
    ry: 74.7
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000159466609607594958910000008931562350174071937_",
    cx: 2783.2385,
    cy: 1187.825,
    r: 536.31,
    gradientTransform: "matrix(-0.9327 -0.3504 0.3504 -0.9327 3097.1897 2841.8674)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F9F2BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67658D"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.515 -0.8572 0.8572 0.515 -204.7402 1147.168)",
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000159466609607594958910000008931562350174071937_)",
      strokeWidth: 8,
      strokeMiterlimit: 10
    },
    cx: 911.4,
    cy: 754.5,
    rx: 750,
    ry: 74.7
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000004536652462959436650000011543003744524917642_",
    cx: 2779.5098,
    cy: 1187.1405,
    r: 534.0224,
    gradientTransform: "matrix(-0.9357 -0.3528 0.3528 -0.9357 3095.3342 2846.7393)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F9F2BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67658D"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3528 -0.9357 0.9357 0.3528 -116.138 1341.1328)",
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000004536652462959436650000011543003744524917642_)",
      strokeWidth: 8,
      strokeMiterlimit: 10
    },
    cx: 911.4,
    cy: 754.5,
    rx: 750,
    ry: 74.7
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000056411947401264694880000014271272740550852017_",
    cx: 1221.726,
    cy: 1752.3531,
    r: 536.31,
    gradientTransform: "matrix(0.1702 0.9818 -0.9818 0.1702 2425.0244 -747.3706)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F9F2BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67658D"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(9.999500e-03 -0.9999 0.9999 9.999500e-03 147.8374 1658.3684)",
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000056411947401264694880000014271272740550852017_)",
      strokeWidth: 8.0004,
      strokeMiterlimit: 10.0005
    },
    cx: 911.4,
    cy: 754.5,
    rx: 74.7,
    ry: 750
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000170265631671286591600000014043297330402198684_",
    cx: 1225.2573,
    cy: 1747.17,
    r: 536.0556,
    gradientTransform: "matrix(0.1736 0.9848 -0.9848 0.1736 2419.2991 -755.5132)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9F2BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1CB5F"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9848 -0.1736 0.1736 0.9848 -117.1747 169.7321)",
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000170265631671286591600000014043297330402198684_)",
      strokeWidth: 8,
      strokeMiterlimit: 10
    },
    cx: 911.4,
    cy: 754.5,
    rx: 750,
    ry: 74.7
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000013174913359990942080000017672894370584784565_",
    cx: 2677.2429,
    cy: 560.6546,
    r: 535.9872,
    gradientTransform: "matrix(-0.5043 -0.8593 0.8593 -0.5043 1783.5042 3344.1582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F9F2BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67658D"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9397 -0.342 0.342 0.9397 -203.0956 357.2328)",
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000013174913359990942080000017672894370584784565_)",
      strokeWidth: 8,
      strokeMiterlimit: 10
    },
    cx: 911.4,
    cy: 754.5,
    rx: 750,
    ry: 74.7
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000069384638452372140560000016335534738903689393_",
    cx: 2675.457,
    cy: 560.6964,
    r: 536.0557,
    gradientTransform: "matrix(-0.5051 -0.863 0.863 -0.5051 1778.9854 3346.782)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9F2BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1CB5F"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.863 -0.5051 0.5051 0.863 -256.3047 563.7311)",
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000069384638452372140560000016335534738903689393_)",
      strokeWidth: 8,
      strokeMiterlimit: 10
    },
    cx: 911.4,
    cy: 754.5,
    rx: 750,
    ry: 74.7
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000009584900409739165330000017469642657423538588_",
    cx: 1833.1025,
    cy: 1979.838,
    r: 536.31,
    gradientTransform: "matrix(-0.5002 0.8618 -0.8618 -0.5002 3539.2246 162.1167)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F9F2BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67658D"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.65 -0.76 0.76 0.65 -254.3762 956.7643)",
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000009584900409739165330000017469642657423538588_)",
      strokeWidth: 8.0004,
      strokeMiterlimit: 10.0005
    },
    cx: 911.4,
    cy: 754.5,
    rx: 74.7,
    ry: 750
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000141426313427283763990000007291412635408406429_",
    cx: 1834.953,
    cy: 1975.6019,
    r: 536.0557,
    gradientTransform: "matrix(-0.5 0.866 -0.866 -0.5 3539.8342 153.2076)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9F2BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1CB5F"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 -197.7176 1166.5881)",
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000141426313427283763990000007291412635408406429_)",
      strokeWidth: 8,
      strokeMiterlimit: 10
    },
    cx: 911.4,
    cy: 754.5,
    rx: 74.7,
    ry: 750
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000157990632687394773670000013123521814046874510_",
    cx: 2184.3064,
    cy: 132.4262,
    r: 536.7126,
    gradientTransform: "matrix(0.166 -0.9825 0.9825 0.166 417.5629 2885.0312)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F9F2BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67658D"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.342 -0.9397 0.9397 0.342 -109.3127 1352.9304)",
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000157990632687394773670000013123521814046874510_)",
      strokeWidth: 8,
      strokeMiterlimit: 10
    },
    cx: 911.4,
    cy: 754.5,
    rx: 74.7,
    ry: 750
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000069398865419675712310000012637939631212493964_",
    cx: 2183.1724,
    cy: 134.4198,
    r: 536.0556,
    gradientTransform: "matrix(0.1678 -0.9858 0.9858 0.1678 412.5833 2884.1836)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9F2BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1CB5F"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1678 -0.9858 0.9858 0.1678 14.672 1526.4255)",
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000069398865419675712310000012637939631212493964_)",
      strokeWidth: 8,
      strokeMiterlimit: 10
    },
    cx: 911.4,
    cy: 754.5,
    rx: 74.7,
    ry: 750
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000093895046245037959520000011068944873128780987_",
    cx: 2161.1926,
    cy: 1924.7961,
    r: 536.31,
    gradientTransform: "matrix(-0.7625 0.6414 -0.6414 -0.7625 3798.9751 838.1341)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F9F2BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67658D"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.869 -0.4949 0.4949 0.869 -253.9582 549.8858)",
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000093895046245037959520000011068944873128780987_)",
      strokeWidth: 8,
      strokeMiterlimit: 10
    },
    cx: 911.4,
    cy: 754.5,
    rx: 74.7,
    ry: 750
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000098215232904215038800000014414318435223721898_",
    cx: 2161.0095,
    cy: 1921.2556,
    r: 536.0557,
    gradientTransform: "matrix(-0.766 0.6428 -0.6428 -0.766 3801.825 837.2195)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9F2BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1CB5F"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.766 -0.6428 0.6428 0.766 -271.7622 762.3846)",
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000098215232904215038800000014414318435223721898_)",
      strokeWidth: 8,
      strokeMiterlimit: 10
    },
    cx: 911.4,
    cy: 754.5,
    rx: 74.7,
    ry: 750
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.75,
      enableBackground: "new"
    },
    width: 1553,
    height: 2576,
    xlinkHref: "61D0347435F4D861.png",
    transform: "matrix(0.24 0 0 0.24 486.72 83.21)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137829507577485289840000000345482646395389057_",
    gradientUnits: "userSpaceOnUse",
    x1: 778.7889,
    y1: 465.06,
    x2: 778.7889,
    y2: -122.8762,
    gradientTransform: "matrix(1 0 0 1 -112.68 214.29)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9F2E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#F9F1E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#F8EFDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#F7EBC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#F6E5AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#F5DD8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#F3D463"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1CB38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137829507577485289840000000345482646395389057_)"
    },
    d: "M567,391.7c-17.9-62.8-21.3-115-21.2-150.1 c0.2-64.2,12.3-86.6,25.1-100.6c4.1-4.5,23.7-25.8,52.7-26.7c34.8-1.2,59.2,27.9,70.7,41.6c28.8,34.3,34,72.8,36.9,97.4 c5.6,46.5-2.5,85-13.4,136c-11.8,55.5-20.3,65.5-16.5,95.1c1.7,13,6.4,34.9,36.9,81.7c27.2,41.5,59.4,79.5,95.9,113.1 c1-29.6,2.1-59.2,3.1-88.8c-15.1-12-29-25.4-41.7-40c-18.4-21.3-29.6-34.3-36.2-53.4c-7.8-22.6-3.7-46.3,4.7-92.7 c7.5-41.5,11.7-47.3,15.7-69.2s17.3-96.2-22-163.5c-10.2-17.4-34-58.1-83.3-73.9c-11.4-3.6-52.2-14.9-94.4,5.5 c-36.6,17.8-52.5,48.9-62.9,69.2c-18.3,35.8-20.1,67.6-22,102.2c-2,37.5,1.2,75.1,9.5,111.7L567,391.7z"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.75,
      enableBackground: "new"
    },
    width: 2597,
    height: 1535,
    xlinkHref: "61D0347435F4D863.png",
    transform: "matrix(0.24 0 0 0.24 202.8 434.81)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052802182761803510040000010352286480121772946_",
    gradientUnits: "userSpaceOnUse",
    x1: 1357.2676,
    y1: 28.895,
    x2: 1357.2676,
    y2: -559.035,
    gradientTransform: "matrix(0.71 -0.71 0.71 0.71 -301.27 1815.4099)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9F2E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#F9F1E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#F8EFDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#F7EBC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#F6E5AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#F5DD8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#F3D463"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1CB38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052802182761803510040000010352286480121772946_)"
    },
    d: "M411.7,741.2 c-57.1-31.8-96.4-66.2-121.1-91.1c-45.2-45.5-52.5-69.9-53.4-88.9c-0.3-6.1-1.5-35,18.3-56.1c23.8-25.5,61.5-22.1,79.5-20.6 c44.6,3.9,75.5,27.5,95,42.8c36.9,28.9,58.3,61.9,86.7,105.6c30.9,47.6,32,60.7,55.6,78.9c10.4,8,29.2,20.2,83.9,31.7 c48.6,10.1,98.2,14.2,147.8,12.2l-60.6-65c-19.2,2.2-38.5,2.5-57.8,1.1c-28-2.1-45.1-3.3-63.3-12.2c-21.5-10.5-35.3-30.1-62.2-68.9 c-24-34.6-25.1-41.8-37.8-60s-55.8-80.3-131.1-100c-19.5-5.1-65.1-17.1-111.1,6.7c-10.6,5.5-47.4,26.3-62.8,70.6 c-13.3,38.4-2.6,71.8,4.4,93.4c12.4,38.3,33.6,62,56.7,87.8c25.1,27.9,53.9,52.2,85.6,72.2L411.7,741.2z"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.75,
      enableBackground: "new"
    },
    width: 2576,
    height: 1553,
    xlinkHref: "61D0347435F4D866.png",
    transform: "matrix(0.24 0 0 0.24 240.48 819.53)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110462311467394565650000015118388245283909812_",
    gradientUnits: "userSpaceOnUse",
    x1: 2082.8022,
    y1: 129.11,
    x2: 2082.8022,
    y2: -458.8301,
    gradientTransform: "matrix(0 -1 1 0 707.5699 3081.73)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9F2E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#F9F1E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#F8EFDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#F7EBC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#F6E5AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#F5DD8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#F3D463"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1CB38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110462311467394565650000015118388245283909812_)"
    },
    d: "M549,1098.1 c-62.8,17.9-115,21.3-150.1,21.2c-64.2-0.2-86.6-12.3-100.6-25.2c-4.5-4.1-25.8-23.7-26.7-52.7c-1.1-34.8,27.9-59.2,41.6-70.7 c34.4-28.8,72.9-34,97.5-36.9c46.5-5.6,85,2.5,136,13.4c55.5,11.8,65.5,20.3,95.1,16.5c13-1.7,34.9-6.4,81.7-36.9 c41.5-27.2,79.5-59.4,113.2-95.9l-88.8-3.1c-12,15.1-25.5,29-40.1,41.7c-21.3,18.4-34.3,29.6-53.4,36.2c-22.6,7.8-46.3,3.7-92.7-4.7 c-41.5-7.5-47.3-11.8-69.2-15.7s-96.2-17.3-163.5,22c-17.4,10.2-58.1,34-73.9,83.3c-3.6,11.3-14.9,52.2,5.5,94.3 c17.7,36.6,48.9,52.5,69.2,62.9c35.8,18.3,67.6,20.1,102.2,22c37.5,2,75-1.1,111.6-9.4C545.4,1139.5,547.2,1118.8,549,1098.1z"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.75,
      enableBackground: "new"
    },
    width: 1535,
    height: 2597,
    xlinkHref: "61D0347435F4D867.png",
    transform: "matrix(0.24 0 0 0.24 592.08 852.89)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084511345295668986660000018269065366480250802_",
    gradientUnits: "userSpaceOnUse",
    x1: 2512.2217,
    y1: 711.9901,
    x2: 2512.2217,
    y2: 124.0701,
    gradientTransform: "matrix(-0.71 -0.71 0.71 -0.71 2308.7 3270.3201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9F2E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#F9F1E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#F8EFDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#F7EBC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#F6E5AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#F5DD8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#F3D463"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1CB38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000084511345295668986660000018269065366480250802_)"
    },
    d: "M898.5,1253.3 c-31.8,57.1-66.2,96.4-91.1,121.2c-45.5,45.2-69.9,52.5-88.9,53.3c-6.1,0.3-35,1.5-56.1-18.3c-25.5-23.8-22.1-61.5-20.6-79.5 c3.9-44.6,27.5-75.5,42.8-95c28.9-36.9,61.9-58.3,105.6-86.7c47.6-30.9,60.7-32,78.9-55.6c8-10.4,20.2-29.2,31.7-83.9 c10.1-48.6,14.2-98.2,12.2-147.8l-65,60.6c2.2,19.2,2.5,38.5,1.1,57.8c-2.1,28-3.3,45.1-12.2,63.3c-10.5,21.5-30.1,35.4-68.9,62.2 c-34.6,24-41.8,25.1-60,37.8s-80.3,55.8-100,131.2c-5.1,19.5-17.1,65.1,6.7,111.2c5.5,10.6,26.3,47.4,70.6,62.8 c38.4,13.3,71.8,2.6,93.4-4.4c38.3-12.4,62-33.6,87.8-56.7c27.9-25.1,52.2-53.9,72.2-85.6L898.5,1253.3z"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.75,
      enableBackground: "new"
    },
    width: 1553,
    height: 2576,
    xlinkHref: "61D0347435F4D862.png",
    transform: "matrix(0.24 0 0 0.24 976.8 820.25)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162349173516072873910000003833949326080306584_",
    gradientUnits: "userSpaceOnUse",
    x1: 2418.7771,
    y1: 1433.1599,
    x2: 2418.7771,
    y2: 845.1698,
    gradientTransform: "matrix(-1 0 0 -1 3575.01 2261.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9F2E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#F9F1E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#F8EFDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#F7EBC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#F6E5AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#F5DD8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#F3D463"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1CB38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162349173516072873910000003833949326080306584_)"
    },
    d: "M1255.3,1116 c17.9,62.8,21.3,115,21.2,150.1c-0.2,64.2-12.3,86.6-25.2,100.6c-4.1,4.5-23.7,25.8-52.7,26.7c-34.8,1.2-59.2-27.9-70.7-41.7 c-28.8-34.3-34-72.8-36.9-97.5c-5.6-46.5,2.5-85,13.4-136c11.8-55.5,20.3-65.5,16.5-95.1c-1.7-13-6.4-34.9-36.9-81.7 c-27.2-41.5-59.4-79.5-95.9-113.2l-3.1,88.8c15.1,12,29,25.5,41.7,40.1c18.4,21.3,29.6,34.3,36.2,53.4c7.8,22.6,3.7,46.3-4.7,92.7 c-7.5,41.4-11.8,47.3-15.7,69.2s-17.3,96.2,22,163.5c10.2,17.4,34,58.1,83.3,73.9c11.3,3.6,52.2,14.9,94.3-5.5 c36.6-17.7,52.5-48.9,62.9-69.2c18.3-35.8,20.1-67.6,22-102.2c2-37.5-1.1-75-9.4-111.6L1255.3,1116z"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.75,
      enableBackground: "new"
    },
    width: 2597,
    height: 1535,
    xlinkHref: "61D0347435F4D86D.png",
    transform: "matrix(0.24 0 0 0.24 1010.16 718.49)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001639734272205698360000005484343000854625672_",
    gradientUnits: "userSpaceOnUse",
    x1: 1830.5244,
    y1: 1868.6829,
    x2: 1830.5244,
    y2: 1280.7629,
    gradientTransform: "matrix(-0.71 0.71 -0.71 -0.71 3763.6099 660.35)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9F2E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#F9F1E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#F8EFDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#F7EBC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#F6E5AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#F5DD8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#F3D463"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1CB38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001639734272205698360000005484343000854625672_)"
    },
    d: "M1410.6,766.6 c57.1,31.8,96.4,66.2,121.2,91.1c45.2,45.5,52.6,69.9,53.3,88.9c0.3,6.1,1.5,35-18.3,56.1c-23.8,25.4-61.5,22.1-79.5,20.6 c-44.6-3.9-75.5-27.5-95-42.8c-36.9-28.9-58.3-61.9-86.7-105.6c-30.9-47.6-32-60.7-55.6-78.9c-10.4-8-29.2-20.2-83.9-31.7 c-48.6-10.1-98.2-14.2-147.8-12.2l60.6,65c19.2-2.2,38.5-2.5,57.8-1.1c28,2.1,45.2,3.3,63.3,12.2c21.5,10.5,35.4,30.1,62.2,68.9 c24,34.6,25.1,41.8,37.8,60s55.8,80.3,131.2,100c19.5,5.1,65.1,17.1,111.1-6.7c10.6-5.4,47.4-26.3,62.8-70.6 c13.3-38.4,2.5-71.8-4.4-93.4c-12.4-38.3-33.6-62-56.7-87.8c-25.1-27.9-53.9-52.2-85.6-72.2L1410.6,766.6z"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.75,
      enableBackground: "new"
    },
    width: 2576,
    height: 1553,
    xlinkHref: "61D0347435F4D86E.png",
    transform: "matrix(0.24 0 0 0.24 977.52 329.45)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005975512816910729710000003310355952126531759_",
    gradientUnits: "userSpaceOnUse",
    x1: 1114.7972,
    y1: 1769.1201,
    x2: 1114.7972,
    y2: 1181.1475,
    gradientTransform: "matrix(0 1 -1 0 2754.76 -605.96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9F2E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#F9F1E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#F8EFDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#F7EBC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#F6E5AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#F5DD8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#F3D463"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1CB38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005975512816910729710000003310355952126531759_)"
    },
    d: "M1273.3,409.7 c62.8-17.9,115-21.3,150.1-21.2c64.2,0.2,86.6,12.3,100.6,25.1c4.5,4.1,25.8,23.7,26.7,52.7c1.2,34.8-27.9,59.2-41.7,70.7 c-34.3,28.8-72.8,34-97.4,36.9c-46.5,5.6-85-2.5-136-13.4c-55.5-11.8-65.5-20.3-95.1-16.5c-13,1.7-34.9,6.4-81.7,36.9 c-41.5,27.2-79.5,59.4-113.2,95.9l88.8,3.2c12-15.1,25.5-29,40.1-41.7c21.3-18.4,34.3-29.6,53.4-36.2c22.6-7.8,46.3-3.7,92.7,4.7 c41.4,7.5,47.3,11.8,69.2,15.7s96.2,17.3,163.5-22c17.4-10.2,58.1-34,73.9-83.3c3.6-11.3,14.9-52.2-5.5-94.3 c-17.8-36.6-48.9-52.5-69.2-62.9c-35.8-18.3-67.6-20.1-102.2-22c-37.5-2-75,1.1-111.6,9.4C1276.9,368.3,1275.1,389,1273.3,409.7z"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.75,
      enableBackground: "new"
    },
    width: 1535,
    height: 2597,
    xlinkHref: "61D0347435F4D86F.png",
    transform: "matrix(0.24 0 0 0.24 875.76 45.53)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085223452752808273540000009566661371100978103_",
    gradientUnits: "userSpaceOnUse",
    x1: 675.6021,
    y1: 1186.2098,
    x2: 675.6021,
    y2: 598.2798,
    gradientTransform: "matrix(0.71 0.71 -0.71 0.71 1153.64 -794.56)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9F2E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#F9F1E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#F8EFDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#F7EBC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#F6E5AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#F5DD8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#F3D463"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1CB38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085223452752808273540000009566661371100978103_)"
    },
    d: "M923.9,254.4 c31.8-57.1,66.2-96.4,91.1-121.1c45.5-45.2,69.9-52.6,88.9-53.3c6.1-0.3,35-1.5,56.1,18.3c25.5,23.8,22.1,61.5,20.6,79.5 c-3.9,44.6-27.5,75.5-42.8,95c-28.9,36.9-61.9,58.3-105.6,86.7c-47.6,30.9-60.7,32-78.9,55.6c-8,10.4-20.2,29.2-31.7,83.9 c-10.1,48.6-14.2,98.3-12.2,147.9l65-60.6c-2.2-19.2-2.5-38.5-1.1-57.8c2.1-28,3.3-45.1,12.2-63.4c10.5-21.5,30.1-35.4,68.9-62.2 c34.6-24,41.8-25.1,60-37.8s80.3-55.8,100-131.2c5.1-19.5,17.1-65.1-6.7-111.1c-5.5-10.6-26.3-47.4-70.6-62.8 c-38.4-13.3-71.8-2.5-93.4,4.5c-38.3,12.4-62,33.6-87.8,56.7c-27.9,25.1-52.2,53.9-72.2,85.6L923.9,254.4z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/Logo2.ccf8d311abc6aee44037f801660e151b.svg";
export { ForwardRef as ReactComponent };